/**
 * Generic Shopify OAuth scope-upgrade URL fetcher.
 *
 * Asks chatbot-api whether the tenant's Shopify token holds the given
 * scopes. If anything's missing, returns a Shopify managed-install URL
 * the merchant can click to grant them — same flow the SEO/SKU agent's
 * `seoProposalNeedsAuth` rich card uses.
 *
 * Used by the home dashboard's Orders & Conversion card to surface a
 * "Reconnect Shopify" CTA when `read_reports` is missing.
 */
import { apiClient } from '@lib/core/api';

export interface ScopeUpgradeResponse {
  ok: boolean;
  missing: string[];
  /** Shopify managed-install URL — empty string when `ok === true`. */
  auth_url: string;
}

export async function getShopifyScopeUpgradeUrl(
  tenantId: string,
  scopes: string[],
): Promise<ScopeUpgradeResponse> {
  const res = await apiClient.chatbotGet<ScopeUpgradeResponse>(
    '/integration/shopify/scope-upgrade-url',
    { tenant_id: tenantId, scopes: scopes.join(',') },
  );
  return res.data;
}
